import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const LogContainer = styled.div`
  height: 100%;
  background-color: ${globals.WHITE};
  padding: 16px;
  /*
    This gets rid of a weird blue border box when you click around the terminal log.
  */
  .ReactVirtualized__Grid {
    outline: none !important;
  }
  .ReactVirtualized__Grid.ReactVirtualized__List {
    padding-bottom: 44px !important;
  }

  @media only screen and (max-width: ${globals.tabletBreakpoint}) {
    margin-top: -${globals.mobileBarHeight};
    padding-top: ${globals.mobileBarHeight};
  }
`;
LogContainer.displayName = 'S.LogContainer';

export const LogHeader = styled.div`
  margin-bottom: 16px;
  display: flex;
  align-items: center;
`;
LogHeader.displayName = 'S.LogHeader';

export const Search = styled.div`
  width: 300px;
`;
Search.displayName = 'S.Search';

export const Truncated = styled.span`
  font-size: 14px;
  color: ${globals.MOON_500};
  margin: 0 16px;
`;
Truncated.displayName = 'S.Truncated';

export const Aligner = styled.span`
  flex: 1 1 auto;
`;
Aligner.displayName = 'S.Aligner';

export const LogText = styled.div`
  background-color: ${globals.MOON_50};
  overflow: auto;
  height: calc(100vh - 60px);
  padding: 16px;
  font-family: monospace;
  font-size: 13px;
  line-height: 16px;
`;
LogText.displayName = 'S.LogText';

export const LineNumber = styled.span`
  color: ${globals.MOON_500};
`;
LineNumber.displayName = 'S.LineNumber';

export const Timestamp = styled.span`
  color: ${globals.BLUE_400};
`;
Timestamp.displayName = 'S.Timestamp';
